module.exports = __webpack_public_path__ + "img/rightfilterwhite.b1b0c808.svg";